module.exports = __webpack_public_path__ + "static/japan07-4ce2bef9a9090b4708bf5d716951dfcb.jpg";